module.exports = __webpack_public_path__ + "static/media/strikethrough.a7b418fe.svg";